"use strict";

exports.__esModule = true;
exports.default = exports.Anchor = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _clsx = _interopRequireDefault(require("clsx"));
var _Icon = _interopRequireDefault(require("../Icon/Icon"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
/**
 * The Anchor component is used as a link to another destination.
 */
const Anchor = exports.Anchor = /*#__PURE__*/_react.default.forwardRef((props, ref) => {
  const {
    to,
    target,
    withNoOpener,
    withNoReferrer,
    label,
    title,
    color,
    disabled,
    underlined,
    icon,
    iconPosition,
    displayAsButton,
    outline,
    size,
    shape,
    className,
    children,
    ...attributes
  } = props;
  const classes = (0, _clsx.default)('uk-anchor', "uk-color--" + color, disabled && 'uk-anchor--disabled', underlined && 'uk-anchor--underlined', iconPosition !== 'left' && 'reverse', icon && !label && !children && 'icon-only', className);
  const buttonClasses = (0, _clsx.default)('uk-anchor', 'uk-button', "uk-bdcolor--" + color, "uk-color--" + color, outline ? "uk-outline--" + color : "uk-bghcolor--" + color, disabled && 'uk-disabled', size !== 'default' && size, shape !== 'default' && shape, iconPosition !== 'left' && 'reverse', icon && !label && !children && 'icon-only', className);
  return /*#__PURE__*/_react.default.createElement("a", _extends({
    href: disabled ? undefined : to,
    className: displayAsButton ? buttonClasses : classes,
    disabled: disabled,
    title: title || label || icon || undefined,
    "aria-label": title || label || icon || undefined,
    target: target,
    rel: target === '_blank' ? (withNoOpener ? 'noopener' : '') + " " + (withNoReferrer ? 'noreferrer' : '') : undefined,
    ref: ref
  }, attributes), icon && /*#__PURE__*/_react.default.createElement(_Icon.default, {
    name: icon
  }), label ? /*#__PURE__*/_react.default.createElement("span", null, label) : children);
});
Anchor.propTypes = {
  /**
   * Label of the Anchor
   */
  label: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.element]),
  /**
   * Destination of the Anchor (href)
   */
  to: _propTypes.default.string,
  /**
   * Destination of the Anchor (target)
   */
  target: _propTypes.default.oneOf(['_self', '_blank']),
  /**
   * Add noopener to the rel attribute when target=_blank
   */
  withNoOpener: _propTypes.default.bool,
  /**
   * Add noreferrer to the rel attribute when target=_blank
   */
  withNoReferrer: _propTypes.default.bool,
  /**
   * Color of the Anchor
   */
  color: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.oneOf(['default', 'primary', 'secondary', 'success', 'alert', 'warning', 'black', 'white', 'custom'])]),
  /**
   * Force the underlined on the Anchor
   */
  underlined: _propTypes.default.bool,
  /**
   * Add an Icon in the Anchor
   */
  icon: _propTypes.default.string,
  /**
   * Alignment of the Icon within the Anchor
   */
  iconPosition: _propTypes.default.oneOf(['left', 'right']),
  /**
   * Set the Anchor as disabled
   */
  disabled: _propTypes.default.bool,
  /**
   * Provide text to aria-label and title attributes of the Anchor
   */
  title: _propTypes.default.string,
  /**
   * Adapt the styling to make the Anchor appears as a Button
   */
  displayAsButton: _propTypes.default.bool,
  /**
   * Size of the Anchor as Button (when it applies)
   */
  size: _propTypes.default.oneOf(['tiny', 'small', 'default', 'large']),
  /**
   * Shape of the Anchor as Button (when it applies)
   */
  shape: _propTypes.default.oneOf(['default', 'round']),
  /**
   * Invert styling colors of the Anchor as Button (when it applies)
   */
  outline: _propTypes.default.bool
};
Anchor.defaultProps = {
  to: '',
  target: '_self',
  label: '',
  title: '',
  icon: '',
  iconPosition: 'left',
  size: 'default',
  color: 'primary',
  shape: 'default',
  disabled: false,
  underlined: true,
  displayAsButton: false,
  outline: false,
  withNoOpener: true,
  withNoReferrer: true
};
var _default = exports.default = Anchor;